module.exports = __webpack_public_path__ + "img/settlement-stamp.6774469d.png";